import login from "@/pages/login.vue";
import dashboard from "@/pages/index.vue";
import placeholder from "@/pages/placeholder.vue";

// ── Feature view imports ────────────────────────────────────────────────────
import ManageAnnouncementsView from "@/features/announcements/ManageAnnouncementsView.vue";
import AnnouncementFormView from "@/features/announcements/AnnouncementFormView.vue";
import ManageMessagesView from "@/features/messages/ManageMessagesView.vue";
import ManageRemindersView from "@/features/reminders/ManageRemindersView.vue";
import ReminderFormView from "@/features/reminders/ReminderFormView.vue";
import ManageNewsEventsView from "@/features/newsEvents/ManageNewsEventsView.vue";
import NewsEventFormView from "@/features/newsEvents/NewsEventFormView.vue";
import ManagePopupsView from "@/features/popups/ManagePopupsView.vue";
import PopupFormView from "@/features/popups/PopupFormView.vue";
import ManagePollsView from "@/features/polls/ManagePollsView.vue";
import PollFormView from "@/features/polls/PollFormView.vue";
import ManagePostsView from "@/features/posts/ManagePostsView.vue";
import PostFormView from "@/features/posts/PostFormView.vue";
import PostsExportView from "@/features/posts/PostsExportView.vue";
import ManagePromotionsView from "@/features/promotions/ManagePromotionsView.vue";
import PromotionFormView from "@/features/promotions/PromotionFormView.vue";
import ManageVideosView from "@/features/videos/ManageVideosView.vue";
import VideoFormView from "@/features/videos/VideoFormView.vue";
import ManageNotificationsView from "@/features/notifications/ManageNotificationsView.vue";
import ManageBDVouchersView from "@/features/vouchers/ManageBDVouchersView.vue";
import BDVouchersUploadView from "@/features/vouchers/BDVouchersUploadView.vue";
import BDVouchersExportView from "@/features/vouchers/BDVouchersExportView.vue";
import ManageMezzofyView from "@/features/vouchers/ManageMezzofyView.vue";
import UploadMezzofyView from "@/features/vouchers/UploadMezzofyView.vue";
import ManageUsersView from "@/features/users/ManageUsersView.vue";
import AddUserView from "@/features/users/AddUserView.vue";
import EditUserView from "@/features/users/EditUserView.vue";
import AddUserPointsView from "@/features/users/AddUserPointsView.vue";
import BatchUsersView from "@/features/users/BatchUsersView.vue";
import ManageTasksView from "@/features/tasks/ManageTasksView.vue";
import TaskFormView from "@/features/tasks/TaskFormView.vue";
import BatchTasksView from "@/features/tasks/BatchTasksView.vue";
import ManageServicesView from "@/features/services/ManageServicesView.vue";
import ServiceFormView from "@/features/services/ServiceFormView.vue";
import ManageCampaignPagesView from "@/features/campaignPages/ManageCampaignPagesView.vue";
import CampaignPageFormView from "@/features/campaignPages/CampaignPageFormView.vue";
import ManageGuidePagesView from "@/features/guidePages/ManageGuidePagesView.vue";
import GuidePageFormView from "@/features/guidePages/GuidePageFormView.vue";
import ManageHomepageSectionsView from "@/features/homepageSections/ManageHomepageSectionsView.vue";
import HomepageSectionFormView from "@/features/homepageSections/HomepageSectionFormView.vue";
import ManageAppVersionsView from "@/features/appVersions/ManageAppVersionsView.vue";
import AppVersionFormView from "@/features/appVersions/AppVersionFormView.vue";
import ManagePointsDistView from "@/features/pointsDistribution/ManagePointsDistributionView.vue";
import ManageRedemptionView from "@/features/redemption/ManageRedemptionView.vue";
import RedemptionFormView from "@/features/redemption/RedemptionFormView.vue";
import ManageStampsView from "@/features/stamps/ManageStampsView.vue";
import StampCardFormView from "@/features/stamps/StampCardFormView.vue";
import RecognitionStampsView from "@/features/stampAdmin/RecognitionStampsView.vue";
import StampLimitsView from "@/features/stampAdmin/StampLimitsView.vue";
import StampGuidelineView from "@/features/stampAdmin/StampGuidelineView.vue";
import FeaturedStampView from "@/features/stampAdmin/FeaturedStampView.vue";
import ManageWheelSummaryView from "@/features/wheel/ManageWheelSummaryView.vue";
import ManageLivestreamView from "@/features/livestream/ManageLivestreamView.vue";
import BatchAddAppleLinksView from "@/features/appleLinks/BatchAddAppleLinksView.vue";
import BatchUploadEmergeneticsView from "@/features/emergenetics/BatchUploadEmergeneticsView.vue";
import ResetPasswordView from "@/features/users/ResetPasswordView.vue";
import ManageQuizzesView from "@/features/quizzes/ManageQuizzesView.vue";
import EditQuizView from "@/features/quizzes/EditQuizView.vue";
import QuizBatchUploadView from "@/features/quizzes/QuizBatchUploadView.vue";
import ManageCampaignVideosView from "@/features/campaignVideos/ManageCampaignVideosView.vue";
import CampaignVideoFormView from "@/features/campaignVideos/CampaignVideoFormView.vue";
import ManageCampaignResponsesView from "@/features/campaignResponses/ManageCampaignResponsesView.vue";
import ManageEventHomePagesView from "@/features/eventHomePages/ManageEventHomePagesView.vue";
import EventHomePageFormView from "@/features/eventHomePages/EventHomePageFormView.vue";
import MessageFormView from "@/features/messages/MessageFormView.vue";
import TemplateFormView from "@/features/messages/TemplateFormView.vue";
import QRNoticesView from "@/features/messages/QRNoticesView.vue";
import FeaturedStampFormView from "@/features/stampAdmin/FeaturedStampFormView.vue";
import PreDrawView from "@/features/luckyDraw/PreDrawView.vue";
import PreDraw2View from "@/features/luckyDraw/PreDraw2View.vue";
import ChangeImageView from "@/features/profile/ChangeImageView.vue";
export const redirects = [
  { path: "/", name: "index", redirect: { name: "dashboard" } },
  { path: "/:pathMatch(.*)*", name: "not-found", redirect: "/dashboard" },
];

export const routes = [
  {
    path: "/login",
    component: login,
    name: "login",
    meta: { layout: "blank", public: true },
  },
  { path: "/dashboard", component: dashboard, name: "dashboard" },

  // ── Manage Communications ──────────────────────────────────────────────
  {
    path: "/announcements",
    name: "announcements",
    component: ManageAnnouncementsView,
  },
  {
    path: "/announcements/new",
    name: "announcements-new",
    component: AnnouncementFormView,
  },
  {
    path: "/announcements/:id/edit",
    name: "announcements-edit",
    component: AnnouncementFormView,
  },

  { path: "/messages", name: "messages", component: ManageMessagesView },
  { path: "/messages/new", name: "messages-new", component: MessageFormView },
  {
    path: "/messages/:id/edit",
    name: "messages-edit",
    component: MessageFormView,
  },
  {
    path: "/messages/templates/new",
    name: "messages-templates-new",
    component: TemplateFormView,
  },
  {
    path: "/messages/qr-notices",
    name: "messages-qr-notices",
    component: QRNoticesView,
  },

  { path: "/reminders", name: "reminders", component: ManageRemindersView },
  {
    path: "/reminders/new",
    name: "reminders-new",
    component: ReminderFormView,
  },
  {
    path: "/reminders/:id/edit",
    name: "reminders-edit",
    component: ReminderFormView,
  },

  {
    path: "/news-events",
    name: "news-events",
    component: ManageNewsEventsView,
  },
  {
    path: "/news-events/new",
    name: "news-events-new",
    component: NewsEventFormView,
  },
  {
    path: "/news-events/:id/edit",
    name: "news-events-edit",
    component: NewsEventFormView,
  },

  { path: "/popups", name: "popups", component: ManagePopupsView },
  { path: "/popups/new", name: "popups-new", component: PopupFormView },
  { path: "/popups/:id/edit", name: "popups-edit", component: PopupFormView },

  { path: "/polls", name: "polls", component: ManagePollsView },
  { path: "/polls/new", name: "polls-new", component: PollFormView },
  { path: "/polls/:id/edit", name: "polls-edit", component: PollFormView },

  { path: "/posts", name: "posts", component: ManagePostsView },
  { path: "/posts/create", name: "posts-create", component: PostFormView },
  { path: "/posts/export", name: "posts-export", component: PostsExportView },

  { path: "/promotions", name: "promotions", component: ManagePromotionsView },
  {
    path: "/promotions/new",
    name: "promotions-new",
    component: PromotionFormView,
  },
  {
    path: "/promotions/:id/edit",
    name: "promotions-edit",
    component: PromotionFormView,
  },

  { path: "/videos", name: "videos", component: ManageVideosView },
  { path: "/videos/new", name: "videos-new", component: VideoFormView },
  { path: "/videos/:id/edit", name: "videos-edit", component: VideoFormView },

  {
    path: "/notifications",
    name: "notifications",
    component: ManageNotificationsView,
  },

  // ── Vouchers ───────────────────────────────────────────────────────────
  {
    path: "/bd-vouchers",
    name: "bd-vouchers",
    component: ManageBDVouchersView,
  },
  {
    path: "/bd-vouchers/upload",
    name: "bd-vouchers-upload",
    component: BDVouchersUploadView,
  },
  {
    path: "/bd-vouchers/export",
    name: "bd-vouchers-export",
    component: BDVouchersExportView,
  },
  {
    path: "/mezzofy-vouchers",
    name: "mezzofy-vouchers",
    component: ManageMezzofyView,
  },
  {
    path: "/mezzofy-vouchers/upload",
    name: "mezzofy-vouchers-upload",
    component: UploadMezzofyView,
  },

  // ── Manage App ─────────────────────────────────────────────────────────
  { path: "/users", name: "users", component: ManageUsersView },
  { path: "/users/new", name: "users-new", component: AddUserView },
  { path: "/users/:id/edit", name: "users-edit", component: EditUserView },
  { path: "/users/batch", name: "users-batch", component: BatchUsersView },
  { path: "/users/points", name: "users-points", component: AddUserPointsView },

  { path: "/tasks", name: "tasks", component: ManageTasksView },
  { path: "/tasks/new", name: "tasks-new", component: TaskFormView },
  { path: "/tasks/:id/edit", name: "tasks-edit", component: TaskFormView },
  { path: "/tasks/batch", name: "tasks-batch", component: BatchTasksView },

  { path: "/services", name: "services", component: ManageServicesView },
  { path: "/services/new", name: "services-new", component: ServiceFormView },
  {
    path: "/services/:id/edit",
    name: "services-edit",
    component: ServiceFormView,
  },

  {
    path: "/campaign-pages",
    name: "campaign-pages",
    component: ManageCampaignPagesView,
  },
  {
    path: "/campaign-pages/new",
    name: "campaign-pages-new",
    component: CampaignPageFormView,
  },
  {
    path: "/campaign-pages/:id/edit",
    name: "campaign-pages-edit",
    component: CampaignPageFormView,
  },

  {
    path: "/guide-pages",
    name: "guide-pages",
    component: ManageGuidePagesView,
  },
  {
    path: "/guide-pages/new",
    name: "guide-pages-new",
    component: GuidePageFormView,
  },
  {
    path: "/guide-pages/:id/edit",
    name: "guide-pages-edit",
    component: GuidePageFormView,
  },

  {
    path: "/homepage-sections",
    name: "homepage-sections",
    component: ManageHomepageSectionsView,
  },
  {
    path: "/homepage-sections/:id/edit",
    name: "homepage-sections-edit",
    component: HomepageSectionFormView,
  },

  {
    path: "/app-versions",
    name: "app-versions",
    component: ManageAppVersionsView,
  },
  {
    path: "/app-versions/:id/edit",
    name: "app-versions-edit",
    component: AppVersionFormView,
  },

  // ── Manage Rewards & Points ────────────────────────────────────────────
  {
    path: "/points-distribution",
    name: "points-distribution",
    component: ManagePointsDistView,
  },

  {
    path: "/redemption-products",
    name: "redemption-products",
    component: ManageRedemptionView,
  },
  {
    path: "/redemption-products/new",
    name: "redemption-products-new",
    component: RedemptionFormView,
  },
  {
    path: "/redemption-products/:id/edit",
    name: "redemption-products-edit",
    component: RedemptionFormView,
  },

  { path: "/stamps", name: "stamps", component: ManageStampsView },
  { path: "/stamps/new", name: "stamps-new", component: StampCardFormView },
  {
    path: "/stamps/:id/edit",
    name: "stamps-edit",
    component: StampCardFormView,
  },

  {
    path: "/recognition-stamps",
    name: "recognition-stamps",
    component: RecognitionStampsView,
  },
  { path: "/stamp-limits", name: "stamp-limits", component: StampLimitsView },
  {
    path: "/stamp-guideline",
    name: "stamp-guideline",
    component: StampGuidelineView,
  },

  {
    path: "/featured-stamp",
    name: "featured-stamp",
    component: FeaturedStampView,
  },
  {
    path: "/featured-stamp/new",
    name: "featured-stamp-new",
    component: FeaturedStampFormView,
  },
  {
    path: "/featured-stamp/:id/edit",
    name: "featured-stamp-edit",
    component: FeaturedStampFormView,
  },

  {
    path: "/wheel-summary",
    name: "wheel-summary",
    component: ManageWheelSummaryView,
  },

  // ── Manage Campaigns ───────────────────────────────────────────────────
  { path: "/quizzes", name: "quizzes", component: ManageQuizzesView },
  {
    path: "/quizzes/batch",
    name: "quizzes-batch",
    component: QuizBatchUploadView,
  },
  { path: "/quizzes/:id/edit", name: "quizzes-edit", component: EditQuizView },

  {
    path: "/campaign-videos",
    name: "campaign-videos",
    component: ManageCampaignVideosView,
  },
  {
    path: "/campaign-videos/new",
    name: "campaign-videos-new",
    component: CampaignVideoFormView,
  },
  {
    path: "/campaign-videos/:id/edit",
    name: "campaign-videos-edit",
    component: CampaignVideoFormView,
  },

  {
    path: "/campaign-responses",
    name: "campaign-responses",
    component: ManageCampaignResponsesView,
  },

  {
    path: "/event-homepages",
    name: "event-homepages",
    component: ManageEventHomePagesView,
  },
  {
    path: "/event-homepages/new",
    name: "event-homepages-new",
    component: EventHomePageFormView,
  },
  {
    path: "/event-homepages/:id/edit",
    name: "event-homepages-edit",
    component: EventHomePageFormView,
  },

  {
    path: "/livestream",
    name: "livestream",
    component: ManageLivestreamView,
  },

  {
    path: "/users/apple-links",
    name: "users-apple-links",
    component: BatchAddAppleLinksView,
  },
  {
    path: "/users/emergenetics",
    name: "users-emergenetics",
    component: BatchUploadEmergeneticsView,
  },
  {
    path: "/users/reset-password",
    name: "users-reset-password",
    component: ResetPasswordView,
  },

  { path: "/predraw", name: "predraw", component: PreDrawView },
  { path: "/predraw2", name: "predraw2", component: PreDraw2View },

  {
    path: "/change_image",
    name: "change-image",
    component: ChangeImageView,
    meta: { layout: "blank", public: true },
  },
];
